import { invertMap } from '@/sections/insights/queryBuilder/entities/common/invert';
import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
  getValueFromQueryFilter,
  getValueFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

const valueMap: Record<string, string> = {
  A: 'Active',
  I: 'Inactive',
  F: 'Frozen',
};

const valueMapInverse = invertMap(valueMap);

/**
 * Reusable field definition for Asset status
 * Translates between API codes and UI values
 */
export const AssetStatus: SimpleFilterDefinition = {
  apiField: 'status',
  uiField: 'Status',
  inputType: 'dropdown',
  getAvailableValues: () => Promise.resolve(['Active', 'Inactive', 'Frozen']),
  operators: ['is', 'is not'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    return {
      field: 'Status',
      operator: getOperatorFromQueryFilter(queryFilter),
      value: getValueFromQueryFilter(valueMap, queryFilter),
    };
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    return {
      field: 'status',
      operator: getOperatorFromSimpleFilter(simpleFilter),
      value: getValueFromSimpleFilter(valueMapInverse, simpleFilter),
      not: getNotFromSimpleFilter(simpleFilter),
    };
  },
};
